(function(){
  let loading = false
  let info_expand = false
  function init(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const order_name = urlParams.get('order_name')

    $(".input_form a.t4s-btn").click(async function(e){
      e.preventDefault();
      const order_name = $(".input_form input").val()
      if(order_name){
        loading = true
        await search(order_name)
        loading = false
      }else{
        alert("Please input Order Number!")
      }
    })

    if(order_name){
      $(".input_form input").val(order_name)
      search(order_name)
    }

    $(".tracking_data .track_info ul").click(function(){
      if(info_expand){
        $(".tracking_data .track_info ul").css("--show-tracking-info-lines-pc", 0)
        $(".tracking_data .track_info ul").css("--show-tracking-info-lines-mobile", 0)
        $(".tracking_data .track_info ul").css("--show-tracking-info-expand-text", "Expand details ...")
        info_expand = false
      }else{
        $(".tracking_data .track_info ul").css("--show-tracking-info-lines-pc", 10)
        $(".tracking_data .track_info ul").css("--show-tracking-info-lines-mobile", 5)
        $(".tracking_data .track_info ul").css("--show-tracking-info-expand-text", "")
        info_expand = true
      }
    })

  }
  async function search(order_name){
    // 用ajax获取api数据，并处理404等出错情况
    $(".t4s-custom-liquid").hide(0)
    await $.ajax({
      url: `https://ecowrd.com/express/${order_name}`,
      success: function(data,status,xhr){
        make_list(data, order_name)
      },
      error: function(xhr,status,error){
        alert(error)
      }
    })
  }
  function make_list(data, order_name){
    let track_list_html = ""
    let line_items = ""
    let status = data.fulfillments[0]
    if(!/^ogl/i.test(order_name)){
      status = data.fulfillments.filter(o=>o.trackingNumber === order_name)[0]
    }
    for(const i of status.trackings.reverse()){
      track_list_html += `<li><div class="remark">${i.track_out_remark}</div><div class="time">${i.time}</div></li>`
    }
    for(const i of status.lineItems){
      const image_url = i.image_url + "&width=100"
      line_items += `<li><img src="${image_url}"><div class="title">${i.name}</div><div class="price">$ ${i.price}</div></li>`
    }
    $(".tracking_data .heading h2").text(status.trackingStatus)
    $(".tracking_data .track_info .list").html(track_list_html)

    $(".tracking_data .order_info .destination .v").text(data.orderDestination)
    $(".tracking_data .order_info .transport_time .v").text(status.transportTime)
    $(".tracking_data .order_info .order_number .v").text(data.orderName)
    $(".tracking_data .order_info .tracking_numbber .v").text(status.trackingNumber)
    $(".tracking_data .order_info .list").html(line_items)
    $(".t4s-custom-liquid").slideDown(300)
  }


  MB_jsDeferHandle(init, ['jQuery'])
}) ()